var Dropdown,
    Popup = require("app/ui/Popup"),
    kind  = require("enyo/kind"),
    utils = require("enyo/utils");

require("app/ui/Dropdown.less");

/**
 * [Dropdown]{@link app.ui.Dropdown}.
 *
 * @ui
 * @class   app.ui.Dropdown
 * @extends enyo.Control
 * @public
 */
Dropdown = module.exports = kind(/** @lends  app.ui.Dropdown.prototype */ {

    /**
     * @private
     */
    name: "app.ui.Dropdown",

    /**
     * @private
     */
    classes: "app-ui-dropdown",

    /**
     * The kind that will remain visible at all times and toggles the
     * dropdown when tapped. If the kind is explicitly set to `null` no
     * activator will be created.
     *
     * @type  {?enyo.Control}
     * @public
     */
    activatorKind: null,

    /**
     * Options for the activator.
     *
     * @type  {Object=}
     * @public
     */
    activatorOptions: null,

    /**
     * The kind that will be revealed as dropdown.
     *
     * @type  {enyo.Control}
     * @public
     */
    dropdownKind: Popup,

    /**
     * Options for the dropdown control
     *
     * @type  {Object=}
     * @public
     */
    dropdownOptions: {
        useScrim:        false,
        floating:        false,
        showCloseButton: false
    },

    /**
     * Whether the dropdown will fade.
     *
     * @type  {boolean}
     * @public
     */
    fade: true,

    /**
    * @private
    */
    events: {
        onDropdownOpen:     "",
        onDropdownRevealed: "",
        onDropdownClose:    "",
        onDropdownHidden:   ""
    },

    /**
     * @private
     */
    handlers: {
        onRequestShowDropdown: "onRequestShowDropdown",
        onRequestHideDropdown: "onRequestHideDropdown"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            this.createActivator();
            this.createDropdown();
            sup.apply(this, arguments);
        };
    }),

    /**
     * @protected
     */
    createActivator: function() {
        var activatorKind    = this.get("activatorKind"),
            activatorOptions = this.getActivatorOptions();

        if (activatorKind !== null) {
            this.createComponent({
                name:     "activator",
                kind:     this.get("activatorKind"),
                classes:  "app-ui-dropdown__activator " + (activatorOptions.classes || ""),
                isChrome: true,
                ontap:    "toggleDropdown"
            }, activatorOptions);
        }
    },

    /**
     * Override this method if the returned options need to change based on the
     * kind that will be used.
     *
     * @param  {Function}  kind   The activatorKind
     * @return {?Object}   The options
     * @public
     */
    getActivatorOptions: function() {
        return this.activatorOptions || {};
    },

    /**
     * @protected
     */
    createDropdown: function() {
        var dropdownOptions = this.getDropdownOptions(),
            $dropdown;

        $dropdown          = this.createComponent({
            name:         "dropdown",
            kind:         this.get("dropdownKind"),
            classes:      "app-ui-dropdown__dropdown " + (dropdownOptions.classes || ""),
            isChrome:     true,
            bubbleTarget: this
        }, dropdownOptions);
        this.controlParent = $dropdown;

        if ($dropdown.on) {
            $dropdown.on("revealing", this.dropdownRevealing, this);
            $dropdown.on("revealed", this.dropdownRevealed, this);
            $dropdown.on("hiding", this.dropdownHiding, this);
            $dropdown.on("hidden", this.dropdownHidden, this);
        }
    },

    /**
     * Override this method if the returned options need to change based on the
     * kind that will be used.
     *
     * @param  {Function}  kind   The dropdownKind
     * @return {?Object}   The options
     * @public
     */
    getDropdownOptions: function() {
        return this.dropdownOptions || {};
    },

    /**
     * Toggles enyo-ui.Popup by default.
     *
     * @public
     */
    toggleDropdown: function() {
        var dropdown = this.$.dropdown;

        if (dropdown.get("showing") || dropdown.get("willShow")) {
            this.hideDropdown();
        }
        else if (!dropdown.get("showing") || dropdown.get("willHide")) {
            this.showDropdown();
        }
    },

    /**
     * Shows the dropdown popup.
     *
     * @public
     */
    showDropdown: function() {
        this.$.dropdown.requestShow(this.get("fade"));
    },

    /**
     * Hides the dropdown popup.
     *
     * @param  {boolean}  hideParents  Whether to bubble a hide request to
     *                                 parent controls.
     * @public
     */
    hideDropdown: function(hideParents) {
        this.$.dropdown.requestHide(this.get("fade"));

        if (hideParents) {
            this.bubbleUp("onRequestHideDropdown");
        }
    },

    /**
     * @return  {boolean}  Stop propagation
     * @protected
     */
    onRequestShowDropdown: function() {
        this.showDropdown();

        return true;
    },

    /**
     * @param   {enyo.Control}  sender  The sender
     * @param   {Object}        event   The event
     * @return  {boolean}       Stop propagation
     * @protected
     */
    onRequestHideDropdown: function(sender, event) {
        this.hideDropdown(event.hideParents);

        return true;
    },

    /**
     * Adds a css flag
     * @protected
     */
    dropdownRevealing: function() {
        !this.hasClass("app-ui-dropdown--open") && this.addClass("app-ui-dropdown--open");
        this.doDropdownOpen();
    },

    /**
     * @protected
     */
    dropdownRevealed: function() {
        this.doDropdownRevealed();
    },

    /**
     * @protected
     */
    dropdownHiding: function() {
        while (this.hasClass("app-ui-dropdown--open")) {
            this.removeClass("app-ui-dropdown--open");
        }
        this.doDropdownClose();
    },

    /**
     * @protected
     */
    dropdownHidden: function() {
        this.doDropdownHidden();
    },

    /**
     * Close the dropdown, so it's scrim won't interfere
     *
     * @memberof app.ui.Dropdown
     * @method
     * @private
     */
    absoluteShowingChanged: kind.inherit(function(sup) {
        return function() {
            var dropdown = this.$.dropdown;

            if (!this.absoluteShowing
                && (dropdown.get("showing") || dropdown.get("willShow"))
            ) {
                this.hideDropdown();
            }
            sup.apply(this, arguments);
        };
    })

});

/**
 * This method allows enyo.kind to extend the `arrangerOptions` and
 * `childOptions` hashes when creating super kinds.
 *
 * @param    {Function}  ctor   The constructor
 * @param    {Object}    props  The properties
 * @memberof Repeater
 * @static
 * @private
 */
Dropdown.concat = function(ctor, props) {
    var proto   = ctor.prototype || ctor,
        options = [
            "activatorOptions",
            "dropdownOptions"
        ];

    options.forEach(function(prop) {
        var baseProp;

        // Merge published property on prototype into base property as needed
        if (proto.published && proto.published.hasOwnProperty(prop)) {
            baseProp    = proto[prop] ? utils.clone(proto[prop]) : {};
            proto[prop] = utils.mixin(baseProp, proto.published[prop]);
            delete proto.published[prop];
        }

        // Merge published property on props into base property as needed
        if (props.published && props.published.hasOwnProperty(prop)) {
            baseProp    = props[prop] ? utils.clone(props[prop]) : {};
            props[prop] = utils.mixin(baseProp, props.published[prop]);
            delete props.published[prop];
        }

        // Extend existing property with incoming property
        baseProp    = proto[prop] ? utils.clone(proto[prop]) : {};
        proto[prop] = utils.mixin(baseProp, props[prop]);
        delete props[prop];
    });
};
